<div windowScrollAppNav class="details-navigation">
  <div class="fl-l big-title" *ngIf="expat">
    {{ expat.user.name }}
  </div>
  <div class="fl-r">
    <app-details-navigation [menu]="menu"></app-details-navigation>
  </div>
</div>

<div class="clear"></div>

<router-outlet></router-outlet>
